export var RelationshipToBorrower;
(function (RelationshipToBorrower) {
    RelationshipToBorrower["FATHER"] = "Father";
    RelationshipToBorrower["MOTHER"] = "Mother";
    RelationshipToBorrower["SPOUSE"] = "Spouse";
    RelationshipToBorrower["BROTHER"] = "Brother";
    RelationshipToBorrower["SISTER"] = "Sister";
    RelationshipToBorrower["SON"] = "Son";
    RelationshipToBorrower["OTHER_RELATIVE"] = "Other Relative";
    RelationshipToBorrower["OTHER"] = "Other";
})(RelationshipToBorrower || (RelationshipToBorrower = {}));
//# sourceMappingURL=RelationshipToBorrower.js.map